// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useContext, forwardRef,
    useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useTranslation, Trans} from 'react-i18next';
import cn from 'classnames';
import {Lang_select} from './lang_select';
import {Link} from './link';
import {use_theme} from '../settings_ctx';
import {get_width, use_screen} from '../lib/screen_util';
import {use_expand} from './use_expand';
import './footer.module.less';
import {App_context} from 'hola_app_context';

const Products_links =({L})=>{
    const {is_client} = useContext(App_context);
    const {expanded, toggle, icon} = use_expand({init_state: false});
    const {width} = use_screen();
    const cls = cn('hola_footer-links_products',
      width<600 && is_client || !expanded ? 'closed' : '');
    const on_cat_click = ()=>{
        if (width>600)
            toggle();
        else
            location.href = '/products/discover';
    };
    return <ul className={cls}>
      <li className="hola_footer-category" onClick={on_cat_click}>
        <Trans>Hola products</Trans>{width>600 && is_client ? icon : null}
      </li>
      <li><L to="/products/extension" data-clickid="footer_pr_ext">
          <Trans>Browser extensions</Trans></L></li>
      <li><L to="/products/mobile" data-clickid="footer_pr_mobile">
        <Trans>Phone apps</Trans></L></li>
      <li><L to="/products/desktop" data-clickid="footer_pr_desktop">
        <Trans>Desktop apps</Trans></L></li>
      <li><L to="/products/tv" data-clickid="footer_pr_tv">
        <Trans>TV apps</Trans></L></li>
      <li><L to="/browser" data-clickid="footer_pr_browser">
        <Trans>Hola Browser</Trans></L></li>
      <li><L to="/products/console" data-clickid="footer_pr_other">
        <Trans>More apps</Trans></L></li>
    </ul>;
};

const Support_links =({L})=>{
    const {expanded, toggle, icon} = use_expand({init_state: false});
    const cls = cn('hola_footer-links_support', !expanded && 'closed');
    return <ul className={cls}>
      <li className="hola_footer-category" onClick={toggle}>
        <Trans>Support</Trans>{icon}
      </li>
      <li><L to="https://support.hola.org/" data-clickid="footer_support">
          <Trans>Help center</Trans></L></li>
      <li><L to="https://support.hola.org/collections/9877284-setup-guides"
        data-clickid="footer_plus_setup">
        <Trans>Setup guides</Trans></L></li>
      <li><L to="https://support.hola.org/collections/9875490-troubleshooting"
        data-clickid="footer_troubleshooting">
        <Trans>Troubleshooting</Trans></L></li>
      <li><L data-clickid="footer_support_billing"
        to="https://support.hola.org/collections/9877287-billing-payments">
        <Trans>Billing and payments</Trans></L></li>
      <li><L to="https://support.hola.org/collections/9877385-account"
        data-clickid="footer_premium_support">
        <Trans>Account support</Trans></L></li>
    </ul>;
};

const Policies_links =({L})=>{
    const {expanded, toggle, icon} = use_expand({init_state: false});
    const cls = cn('hola_footer-links_policy', !expanded && 'closed');
    return <ul className={cls}>
      <li className="hola_footer-category" onClick={toggle}>
        <Trans>Policies & Press</Trans>{icon}
      </li>
      <li><L to="/legal/privacy" data-clickid="footer_privacy">
        <Trans>Privacy</Trans></L></li>
      <li><L to="/legal/sla" data-clickid="footer_terms">
        <Trans>Terms</Trans></L></li>
      <li><L to="/legal/dmca" data-clickid="footer_dmca">
        <Trans>DMCA Policy</Trans></L></li>
    </ul>;
};

const About_links =({L})=>{
    const {expanded, toggle, icon} = use_expand({init_state: false});
    const cls = cn('hola_footer-links_about', !expanded && 'closed');
    return <ul className={cls}>
      <li className="hola_footer-category" onClick={toggle}>
        <Trans>About Hola</Trans>{icon}
      </li>
      <li><L to="/about" data-clickid="footer_about">
        <Trans>About us</Trans></L></li>
      <li><L to="/blog" data-clickid="footer_blog">
        <Trans>Blog</Trans></L></li>
      <li><a href="/media"><Trans>Media</Trans></a></li>
    </ul>;
};

const Get_in_touch_links =({L})=>{
    const {expanded, toggle, icon} = use_expand({init_state: false});
    const cls = cn('hola_footer-links_get_in_touch', !expanded && 'closed');
    return <ul className={cls}>
      <li className="hola_footer-category" onClick={toggle}>
        <Trans>Get in touch</Trans>{icon}
      </li>
      <li><L to="/contact" data-clickid="footer_contact">
        <Trans>Contact Us</Trans></L></li>
      <li><a href="mailto:abuse@hola.org"><Trans>Report Abuse</Trans></a></li>
      <li><a href="/static/press_kit/press_kit.zip"
        data-clickid="footer_press_kit"><Trans>Press Kit</Trans></a></li>
    </ul>;
};

const Lang_dropdown = ({t_enabled, theme_name, r_translation})=>{
    const is_hola2023 = theme_name=='hola2023';
    const opt = {
        white: !is_hola2023,
        full: is_hola2023,
    };
    return t_enabled && theme_name!='purple' &&
      <div className="hola_footer-links_lang">
        <Lang_select r_translation={r_translation} {...opt}/></div>;
};

export const Hola_footer = forwardRef<HTMLDivElement>(
    function Hola_footer(props:object_of<any>, ref){
    const {theme, theme_name} = use_theme({def: 'hola2023'});
    const {host, t_enabled, r_translation, route_opt = {}} = props;
    const {external_links, footer = {}} = route_opt;
    const _Link = link_props=>external_links ? <Link {...link_props}
      target="_blank" rel="noopener noreferrer"/> : <Link {...link_props}/>;
    const is_hola2023 = theme_name=='hola2023';
    let {is_portal, is_plus} = useContext(App_context);
    let {pathname} = useLocation();
    let [show_links, set_show_links] = useState<boolean>(['/', '/sites']
        .includes(pathname) || is_hola2023);
    useEffect(()=>{
        if (pathname=='/' && (is_portal || host=='holavpn.com' &&
            get_width()<992))
        {
            return;
        }
    }, [pathname]);
    let toggle = ()=>{
        set_show_links(!show_links);
        if (!show_links)
        {
            setTimeout(()=>window.scrollTo({
                left: 0,
                top: document.body.scrollHeight,
                behavior: 'smooth',
            }), 500);
        }
    };
    let hide_toggle = ['/premium', '/ultra',
        '/download_android'].includes(pathname);
    let toggle_cls = cn('hola_footer-toggle', show_links && 'opened',
        hide_toggle && 'hidden');
    let footer_cls = cn('hola_footer', footer.cls,
        'footer_pg-'+(pathname.replace(/^.*\//, '')||'hp'), {
            portal: is_portal,
            dark: theme_name=='dark',
            purple: theme_name=='purple',
            hola2023: is_hola2023,
            free: !is_plus && ['/', '/sites'].includes(pathname),
        });
    let copy_cls = cn(is_hola2023 && theme.u5);
    useTranslation();
    return <div className={cn(theme.root, footer_cls)}>
      <div className={cn('hola_footer-container', theme.container)}>
        <div className="hola_footer-bg"/>
        <div className="hola_footer-hr"/>
        <div className={cn('hola_footer-links_wrapper', show_links && 'show')}>
          <div className={`hola_footer-links v2 ${theme_name}`}>
            <Products_links L={_Link}/>
            <Support_links L={_Link}/>
            <Policies_links L={_Link}/>
            <About_links L={_Link}/>
            <Get_in_touch_links L={_Link}/>
            <Lang_dropdown theme_name={theme_name} t_enabled={t_enabled}
              r_translation={r_translation}/>
          </div>
        </div>
        <div className="row hola_footer-bottom">
          <div className={copy_cls}>
            &copy; Copyright 2025 Hola&nbsp;VPN&nbsp;Ltd. <span>|</span>{` `}
            All&nbsp;rights reserved
          </div>
          {t_enabled && theme_name=='purple' && <div className="lang_select">
            <Lang_select r_translation={r_translation} white
              purple={theme_name=='purple'}/></div>}
          <div className="hola_footer-bottom_links">
            <a className={toggle_cls} onClick={toggle}>
              <div className="hola_footer-toggle_tooltip">
                {show_links ? 'Close' : 'Open'} footer
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-portal" ref={ref}/>
    </div>;
});
